// tslint:disable
export enum ContactTimePreferenceType {
    /**
     * @description UNKNOWN
     */
    UNKNOWN = 0,
    /**
     * @description TIME OF THE DAY
     */
    TIMEOFTHEDAY = 1,
    /**
     * @description BETWEEN TIMES
     */
    BETWEENTIMES = 2,
    /**
     * @description ANY TIME
     */
    ANYTIME = 3,
    /**
     * @description BUSINESS HOURS
     */
    BUSINESSHOURS = 4,
    /**
     * @description EVENING TIMES
     */
    EVENINGTIMES = 5,
    /**
     * @description MORNING TIMES
     */
    MORNINGTIMES = 6,
    /**
     * @description AFTERNOON TIMES
     */
    AFTERNOONTIMES = 7,
}
